module.exports = __webpack_public_path__ + "ff8b209ed8a2e2be954dce1f3d727a11.svg";